import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=0ae55325&scoped=true&"
import script from "./CV.vue?vue&type=script&lang=js&"
export * from "./CV.vue?vue&type=script&lang=js&"
import style0 from "./CV.vue?vue&type=style&index=0&id=0ae55325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae55325",
  null
  
)

export default component.exports